import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";

@Component({
  selector: "app-pagination-button",
  templateUrl: "./pagination-button.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./pagination-button.component.scss",
})
export class PaginationButtonComponent {
  public readonly page: InputSignal<number> = input.required<number>();
  public readonly selected: InputSignal<boolean> = input<boolean>(false);

  public readonly pageChange: OutputEmitterRef<number> = output<number>();

  public onClick(): void {
    this.pageChange.emit(this.page());
  }
}
